//  ----------      START   IMPORT  BLOCK       ----------
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';

import ProtectedRoute from './ProtectedRoute';
import OnboardingGuard from './OnboardingGuard';

//  Context Provider for Active Patient Chart
import { ActivePatientProvider } from '../API/Hooks/ActivePatientContext'; // <-- Adjust import path if needed

import RegisterForm from '../Components/Widgets/General/LandingPage/RegisterWidget/RegiseterWidget.js';
import ProfileOnboarding from '../Components/Widgets/LoggedUserGeneral/ProfileOnboarding/ProfileOnboarding'
import ProOnboarding from '../Components/Widgets/LoggedUserGeneral/ProOnboarding/ProOnboarding';
import ProToPatient from '../Components/Widgets/LoggedUserGeneral/ProToPatient/ProToPatient'
import VerificationScreen from '../Components/VerificationScreen/VerificationScreen';
import AuthForm from '../Components/Widgets/General/LandingPage/AuthForm/AuthForm';

import SearchPage from '../Components/Widgets/General/LandingPage/SearchPage/SearchPage'
import LandingPage from '../Components/Forms/LandingPage/LandingPage';
import ProfessionalsBasePage from '../Components/Widgets/General/LandingPage/Professionals/ProfessionalsBasePage'
import PatientsBasePage from '../Components/Widgets/General/LandingPage/Patients/PatientsBasePage';
import AboutBasePage from '../Components/Widgets/General/LandingPage/About/AboutBasePage';
import RegisterProfessionalPage from '../Components/RegisterProfessionalForm/RegisterProfessionalPage';
import SocialsPage from '../Components/Forms/LandingPage/Socials/socialsPage';
import ConfirmEmail from '../Components/Widgets/General/LandingPage/ConfirmEmail/ConfirmEmail';
import VerificationPending from '../Components/Widgets/Professional/VerificationPending/VerificationPending';
import HelpProManual from '../Components/Forms/Professional/helpProManual';

import RequestAllowanceWidget from '../Components/RequestAllowanceWidget/RequestAllowanceWidget'
import InvitationWidget from '../Components/Widgets/General/LandingPage/InvitationWidget/InvitationWidget';

import OnboardingSuccessTester from '../Components/Widgets/LoggedUserGeneral/OnboardingSuccessTester';
import OnboardingSuccess from '../Components/Widgets/LoggedUserGeneral/ProfileOnboarding/OnboardingSuccess';

import Dashboard from '../Components/Dashboard/Dashboard';
import StatusPage from '../Components/Widgets/General/LandingPage/StatusPage/StatusPage';

//  Config
import { FRONTEND_ROUTES } from '../ConfigFiles/Routes/frontend_routes.js';
//  ----------      END   IMPORT  BLOCK       ----------

/**
 * Scoped Layout Wrapper
 * Ensures ActivePatientProvider is strictly mounted during authenticated clinical/dashboard sessions.
 */
const ActivePatientLayout = () => {
    return (
        <ActivePatientProvider>
            <Outlet />
        </ActivePatientProvider>
    );
};

const AppRoutes = () => {

    return (
        <Routes>

            {/* Handle the ghost path so it doesn't hit the Red Box */}
            {/* <Route path="/index.html" element={<Navigate to={FRONTEND_ROUTES.landing} replace />} />*/}

            <Route path="test" element={<OnboardingSuccessTester/>}/>
            
            <Route path={FRONTEND_ROUTES.onboarding_success} element={<OnboardingSuccess/>}/>
            <Route path={FRONTEND_ROUTES.pro_verification_pending} element={<VerificationPending/>}/>

            {/* 1. GRUPO: REDIRECCIONES Y PÁGINAS PÚBLICAS DE ATERRIZAJE (LANDING) */}
            <Route path="/" element={<Navigate to={FRONTEND_ROUTES.landing} replace />} />
            <Route path={FRONTEND_ROUTES.landing} element={<LandingPage/>}/>
            <Route path={FRONTEND_ROUTES.auth} element={<AuthForm/>}/>
            <Route path={FRONTEND_ROUTES.socials} element={<SocialsPage/>}/>
            <Route path={FRONTEND_ROUTES.confirm_email} element={<ConfirmEmail/>}/>
            <Route path={FRONTEND_ROUTES.profile_onboarding} element={<ProfileOnboarding/>}/>
            <Route path={FRONTEND_ROUTES.pro_onboarding} element={<ProOnboarding/>}/>
            <Route path={FRONTEND_ROUTES.pro_to_patient} element={<ProToPatient/>}/>

            {/* Sub-Rutas de Landing */}
            <Route path={FRONTEND_ROUTES.relative_search} element={<SearchPage/>}/>
            <Route path={FRONTEND_ROUTES.relative_professionals} element={<ProfessionalsBasePage/>}/>
            <Route path={FRONTEND_ROUTES.relative_about} element={<AboutBasePage/>}/>
            <Route path={FRONTEND_ROUTES.relative_patients} element={<PatientsBasePage/>}/>

            {/* 2. GRUPO: FLUJO DE REGISTRO Y VERIFICACIÓN */}
            <Route path={FRONTEND_ROUTES.register} element={<RegisterForm/>}/>
            <Route path={FRONTEND_ROUTES.register_professional} element={<RegisterProfessionalPage/>}/>
            <Route path={FRONTEND_ROUTES.verify} element={<VerificationScreen/>}/>

            {/* 3. GRUPO: WIDGETS Y ACCESOS ESPECIALES */}
            <Route path={FRONTEND_ROUTES.request_access_static} element={<RequestAllowanceWidget/>}/>
            <Route path={FRONTEND_ROUTES.request_access_dynamic} element={<RequestAllowanceWidget/>}/>
            <Route path={FRONTEND_ROUTES.invited_static} element={<InvitationWidget/>}/>
            <Route path={FRONTEND_ROUTES.invited_dynamic} element={<InvitationWidget/>}/>

            {/* Manual routes group */}
            <Route path={FRONTEND_ROUTES.professionals_manual} element={<HelpProManual/>}/>

            {/* PROTECTED & ONBOARDED CLINICAL DASHBOARD GROUP */}
            <Route element={<ProtectedRoute />}>
                <Route element={<OnboardingGuard />}>
                    {/* ActivePatientProvider ONLY wraps authenticated & onboarded routes */}
                    <Route element={<ActivePatientLayout />}>
                        <Route path={FRONTEND_ROUTES.dashboard} element={<Dashboard />} />
                        {/* Any future clinical/dashboard sub-routes go here */}
                    </Route>
                </Route>
            </Route>

            {/* Catch-all for any URL that doesn't match above */}
            <Route path="*" element={<StatusPage code="404" />} />
        </Routes>
    );
};

export default AppRoutes;